<template>
    <div class="link-address-modal-item">
        <div class="link-address-modal-item-title">
            <span class="link-address-modal-item-title-text">{{title}}</span>
            <link-segment/>
        </div>
        <link-justify-wrapper :data="list">
            <link-justify-item v-for="(item,index) in list"
                               :key="index"
							   :class="{'link-address-modal-item-check':currentValue && currentValue.indexOf(item) > -1}"
                               @click.native="handleClick(item)"
                               @dblclick.native="$emit('confirm',item)">
                <span>{{item}}</span>
            </link-justify-item>
        </link-justify-wrapper>
    </div>
</template>

<script>
    export default {
        name: "link-address-modal-item",
        props: {
            value: {},
            list: {},
            title: {},
			mutiple: {type: Boolean, default: false},                                                      // 是否多选
        },
        watch: {
            value(val) {
                if (this.currentValue !== val) this.currentValue = val;
            },
        },
        data() {
            return {
                currentValue: this.value
            }
        },
        methods: {
			handleClick(val) {
				// @updated by changjiufu 满足单个 省 市 县可以多选的情况
				if (this.mutiple && this.currentValue && this.currentValue.indexOf(val) > -1) {
					const index = this.currentValue.indexOf(val);
					this.currentValue = this.currentValue.substring(0, index - 1) + this.currentValue.substring(index ? index + val.length : index + val.length + 1, this.currentValue.length);
				} else if(this.mutiple && this.currentValue && this.currentValue.indexOf(val) === -1) {
					this.currentValue += ',' + val;
				} else {
					this.currentValue = val
				}
				this.$emit('input', this.currentValue);
			},
        },
    }
</script>

<style lang="scss">
    @include themeify {
        .link-address-modal-item {
            box-sizing: border-box;
            .link-justify-wrapper {
                margin: 12px 0;
            }
            .link-justify-item {
                padding: 4px 8px;
                cursor: pointer;
                color: $color-normal-content;
                &.link-address-modal-item-check {
                    background-color: $color-primary;
                    color: white;
                }
            }
            .link-address-modal-item-title {
                display: flex;
                align-items: center;
                .link-address-modal-item-title-text {
                    padding: 4px 8px;
                    color: $color-primary;
                }
                .link-segment {
                    flex: 1;
                    background-color: #ddd;
                    height: 1px;
                }
            }
        }
    }
</style>
